import React from "react"
import clsx from "clsx"
import styles from "./table.module.css"

export function Table({ children, striped = false }) {
  return (
    <div className={styles.wrapper}>
      <table
        className={clsx(
          styles.table,
          striped && styles.tableStriped,
        )}
      >
        {children}
      </table>
    </div>
  )
}
